export default __webpack_public_path__ + "static/for-mf-3cae7d8c1cfb781ab16820329aacd227.jpeg";